// extracted by mini-css-extract-plugin
module.exports = {"body-title":"BodyTitle__body-title___bMux-"};